import {
  AgentCardDto,
  AgentCardId,
  AgentProfileDto,
  EtxeApiSlugs,
  ListPagination,
} from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../../../api-caller.service';
import { ApiConnector } from '../../../../../api-connector.abstract-service';
import { QueryParamsUtils } from '../../../../../utils';

export class EtxeAgentCardsAdminConnector extends ApiConnector<AgentCardDto, AgentCardDto, AgentCardId> {
  constructor(apiCaller: ApiCaller, apiPrefix: string) {
    super(apiCaller, apiPrefix, EtxeApiSlugs.AGENT_CARDS);
  }

  list = (pagination?: ListPagination): Observable<AgentCardDto[]> =>
    this.apiCaller.getRequest<AgentCardDto[]>(
      this.apiPrefix,
      `${this.slug}/all${QueryParamsUtils.buildFilterParams(pagination)}`,
    );

  count = (pagination?: ListPagination): Observable<number> =>
    this.apiCaller.getRequest<number>(
      this.apiPrefix,
      `${this.slug}/all/count${QueryParamsUtils.buildFilterParams(pagination, true)}`,
    );

  getAgents = (agentCardId: AgentCardId, pagination?: ListPagination): Observable<AgentProfileDto[]> =>
    this.apiCaller.getRequest<AgentProfileDto[]>(
      this.apiPrefix,
      `${this.slug}/${agentCardId}/agents${QueryParamsUtils.buildFilterParams(pagination)}`,
    );

  countAgents = (agentCardId: AgentCardId, pagination?: ListPagination): Observable<number> =>
    this.apiCaller.getRequest<number>(
      this.apiPrefix,
      `${this.slug}/${agentCardId}/agents/count${QueryParamsUtils.buildFilterParams(pagination, true)}`,
    );
}
